import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Vademécum de Fórmulas y Cálculos',
  desc: 'Harris-Benedict, Mifflin, IMC, VCT y requerimientos por patología.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Machete de Laboratorio Clínico',
  desc: 'Valores de referencia e interpretación de análisis para prácticas hospitalarias.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Manual de TPs Resueltos',
  desc: 'Modelos completos con el formato y lenguaje que piden los docentes.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Banco de Preguntas de Exámenes',
  desc: '+200 preguntas de parciales y finales con respuestas desarrolladas.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Pocket de Prácticas Clínicas',
  desc: 'Valoración nutricional, antropometría y protocolos de intervención.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Guía de Nutrición Deportiva Aplicada',
  desc: 'Requerimientos, suplementación e hidratación para deportistas.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(254,242,242) 100%)'
  }} data-id="element-38">
      <div className="mx-auto max-w-4xl" data-id="element-39">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-40">
          Más los <span className="text-green-700" data-id="element-41">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-42">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-43">
          {/* Header */}
          <div className="bg-green-700 px-5 py-2.5" data-id="element-44">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-45">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          {/* List */}
          <div className="divide-y divide-gray-100" data-id="element-46">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2.5" data-id="element-47">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-48">
                  {bonus.num}
                </span>

                <div className="flex-1 min-w-0" data-id="element-49">
                  <span className="block text-sm font-black text-gray-900" data-id="element-50">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-51">
                    {bonus.desc}
                  </span>
                </div>

                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-52">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-53">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5" data-id="element-54">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(240, 253, 244)',
        border: '1px solid rgba(34, 197, 94, 0.3)'
      }} data-id="element-55">
          <p className="text-xs font-bold uppercase tracking-widest text-green-700 m-0 mb-1" data-id="element-56">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-57">
            <span className="text-base text-gray-400 line-through" data-id="element-58">
              $58.000
            </span>
            <span className="text-lg font-black text-green-700" data-id="element-59">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}